import { getEnv } from '@u/env'

const server_staging_host = '//staging-iap.aptostar.com'

// 集群对应的服务端host
const ru_cluster = {
  staging: server_staging_host, // 服务端测试环境域名
  preview: '//ru-iap.aptostar.com', // 服务端预发环境域名
  production: '//ru-iap.aptostar.com', // 服务端生产环境域名
}

export const getServerHost = () => {
  const { protocol } = window.location
  const env = getEnv()
  if (env === 'dev') {
    return `https://${server_staging_host}`
  }
  if (env === 'staging') {
    return `${protocol}${server_staging_host}`
  }
  const host = ru_cluster[getEnv()] || ''
  return `${protocol}${host}`
}
// 默认语言
export const defaultLanguage = 'en_US'
// 默认语言对应的config key
export const defaultLanguageKey = 'en'
// 支持的语言，在此之外用默认
export const supportLanguage = {
  ru: 'ru_RU',
  en: 'en_US',
  id: 'in_ID',
  in: 'in_ID',
}

// 将native语言和const key(region)进行对应
export const handleLanguage2Region = (oriLanguage = '') => {
  const language = oriLanguage?.toLowerCase()
  return Object.keys(supportLanguage).includes(language)
    ? language
    : defaultLanguageKey
}
